<div class="modal-overlay custom-field-dialog" mat-dialog-content>
  <div  class="AddEndpoints modal-content">
    <div class="bottom-left-img">
      <img src="assets/images/grpLogo.svg" alt="" class="logo-img">
    </div>
    <div class="modalHead">
      <h3>{{'Custom Field' | translate}}</h3>
    </div>
    <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
    <div class="modalBody">

      <div class="mb-4">
        <div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{'Name' | translate}}</mat-label>
                <input matInput [(ngModel)]="customField.name" required />
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-tag"></i>
                </mat-icon>
                <mat-error>{{'Name' | translate}} {{'is required' | translate}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{'Type' | translate}}</mat-label>
                <mat-select [(ngModel)]="customField.type" required>
                  @for (customFieldType of customFieldTypes; track trackById($index, customFieldType)) {
                    <mat-option [value]="customFieldType.id">
                      {{customFieldType.value}}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-file-alt"></i>
                </mat-icon>
                <mat-error>{{'Type' | translate}} {{'is required' | translate}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12">
              <mat-checkbox color="primary" [(ngModel)]="customField.isPii">
                {{ 'PII field' | translate }}
              </mat-checkbox>
            </div>

            @if (customField.type === CustomFieldTypeEnum.SingleSelect) {
              <div class="col-md-12">
                <mat-form-field>
                  <mat-label>{{ 'Values (comma-delimited)' | translate }}</mat-label>
                  <input matInput [(ngModel)]="customField.data" required />
                  <mat-icon matPrefix class="mr-3">
                    <i class="fas fa-tag"></i>
                  </mat-icon>
                  <mat-error>Values {{'are required' | translate}}.</mat-error>
                </mat-form-field>
              </div>
            }
          </div>
        </div>

        <div class="createButton mt-4">
          <button class="btn finalSubmit modal-footer-btn save-modal-btn" (click)="ok()" [disabled]="isDisabled()">
            {{'Add' | translate}}
          </button>
        </div>

        <div class="createButton mt-4">
          <button class="btn finalSubmit modal-footer-btn cancel-modal-btn" mat-dialog-close>
            {{'Cancel' | translate}}
          </button>
        </div>

      </div>
    </div>
  </div>